import { render, staticRenderFns } from "./answerdata.vue?vue&type=template&id=3297f903&scoped=true&"
import script from "./answerdata.vue?vue&type=script&lang=js&"
export * from "./answerdata.vue?vue&type=script&lang=js&"
import style0 from "./answerdata.vue?vue&type=style&index=0&id=3297f903&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3297f903",
  null
  
)

export default component.exports